import React from "react";
import Modal from "./Modal";
import NewsContentRenderer from "./NewsContentRenderer";
import {buildNewsImageUrl} from "../utils";

export default function NewsPreview({article, onClose}) {
    if (!article) return null;
    const document = JSON.parse(article.content_json);
    const imageUrl = buildNewsImageUrl(article.cover_image_url);
    return (
        <Modal title={`Prévisualisation — ${article.title}`} onClose={onClose} scrollable>
            {imageUrl && (
                <img src={imageUrl} alt={article.cover_image_alt || ""} style={{maxWidth: "100%", borderRadius: 8, marginBottom: 12}}/>
            )}
            <NewsContentRenderer document={document}/>
            {article.external_url && (
                <a href={article.external_url} target="_blank" rel="noopener noreferrer">{article.external_link_label}</a>
            )}
        </Modal>
    );
}
